
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {MinimalDocumentModel} from "@/api-client";

    @Component
    export default class DocumentValidity extends Vue {
        @Prop({required: true})
        details!: MinimalDocumentModel;
    }
